import Service from './service'
import { useCollapse } from '../contextProviders/CollapseContext';
import Status from './StateIconFromObject';
import { ICategory } from '../../rz-status_models';

export default function Subcategory({sub, hideState = false}: {sub: ICategory, hideState: boolean})  {
  const { expanded, toggle } = useCollapse();
  const isExpanded = expanded.includes(sub.id);

  return <li className={"sub collapsible" + (isExpanded ? " open" : "")}>
    <button onClick={() => {toggle(sub.id)}} aria-expanded={isExpanded ? "true" : "false"} aria-controls={`category_${sub.id}`} aria-label={`Serviceübersicht zu "${sub.name}" ${isExpanded ? "zuklappen" : "aufklappen"}`}>
        <span className="icon indicator"/><span className="overflow">{sub.name}</span> {!isExpanded && !hideState && <Status item={sub}/>}
    </button>
    <div id={`category_${sub.id}`} className="details collapsible-content" >
      {(sub.services && sub.services.length > 0)? <ul aria-label={`Services für ${sub.name}`}>
        {sub.services.map(s => <Service key={s.id} service={s} hideState={hideState}/>)}
      </ul> : ""}
      {(sub.categories && sub.categories.length > 0)? <ul aria-label={`Unterkategorien für ${sub.name}`}>
        {sub.categories.map(s => <Subcategory key={s.id} sub={s} hideState={hideState}/>)}
      </ul> : ""}
    </div>
  </li>
}